var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ci",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00cd00",
    d: "M426.8 0H640v480H426.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9a00",
    d: "M0 0h212.9v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M212.9 0h214v480h-214z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCi);
export default __webpack_public_path__ + "static/media/ci.c7146bc39c724cd34b46e01e2487c78a.svg";
export { ForwardRef as ReactComponent };